// src/firebase-config.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

// Firebase configuration object (replace with your own Firebase project details)
const firebaseConfig = {
    apiKey: "AIzaSyBsyvcFeSy-99kyitIG7NgD1Fe1kb3U1k0",
    authDomain: "brickbucket-app.firebaseapp.com",
    projectId: "brickbucket-app",
    storageBucket: "brickbucket-app.firebasestorage.app",
    messagingSenderId: "692726121492",
    appId: "1:692726121492:web:80de6001e2bd7f67fc1301",
    measurementId: "G-E8VMRQNTXB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const messaging = getMessaging(app);

// ✅ Only create messaging if supported
const messagingPromise = isSupported().then((supported) => {
    if (supported) {
        const messaging = getMessaging(app);
        return messaging;
    } else {
        console.warn("Firebase Messaging is not supported in this browser.");
        return null;
    }
});

export { /* messaging , */ messagingPromise, getToken, onMessage };
